<template>
  <div class="vue_body_min_height">
    <div id="news_top_img" v-if="currentBanner != null">
      <img :src="currentBanner.url">
    </div>

    <div id="sub_menu_outer" v-if="newsId == undefined">
      <div id="sub_menu_content">
        <a :href="currentMenuItem.src + '/' + subList[index].id"
           v-for="(item, index) in tabList"
           :key="'news_sub_menu_tab_' + index"
           :class="[index == currentIndex ? 'active' : '']"
        >
          <img :src="index == currentIndex ? item.selected : item.normal">
        </a>
      </div>
    </div>

    <div class="container-fluid" id="news_content_outer" v-if="newsId == undefined">
      <div id="news_content">
        <new-list v-if="currentIndex == 0" />
        <latest-news-list v-if="currentIndex == 1" />
        <video-news-list v-if="currentIndex == 2" />
        <picture-news-list v-if="currentIndex == 3" />
      </div>
    </div>

    <div v-else id="">
      <news-detail />
    </div>

  </div>
</template>

<script>
import OfficialNormalImage from '../assets/shl_news_center_official_normal.png';
import OfficialSelectedImage from '../assets/shl_news_center_official_selected.png';
import LatestNormalImage from '../assets/shl_news_center_latest_normal.png';
import LatestSelectedImage from '../assets/shl_news_center_latest_selected.png';
import VideosNormalImage from '../assets/shl_news_center_videos_normal.png';
import VideosSelectedImage from '../assets/shl_news_center_videos_selected.png';
import PicturesNormalImage from '../assets/shl_news_center_pictures_normal.png';
import PictureSelectedImage from '../assets/shl_news_center_pictures_selected.png';
import GlobalInstance from "../js/shba";

import NewList from "../components/news/OfficialNewsList";
import LatestNewsList from "../components/news/LatestNewsList";
import VideoNewsList from "../components/news/VideoNewsList";
import PictureNewsList from "../components/news/PictureNewsList";
import NewsDetail from "../components/news/NewsDetail";
export default {
  name: "NewCenterPage",
  components: {NewsDetail, PictureNewsList, VideoNewsList, LatestNewsList, NewList},
  data() {
    return {
      title: '新闻中心',
      tabList: [
        {
          title: '官方消息',
          normal: OfficialNormalImage,
          selected: OfficialSelectedImage
        },
        {
          title: '最新动态',
          normal: LatestNormalImage,
          selected: LatestSelectedImage
        },
        {
          title: '精彩视频',
          normal: VideosNormalImage,
          selected: VideosSelectedImage
        },
        {
          title: '精彩图片',
          normal: PicturesNormalImage,
          selected: PictureSelectedImage
        },
      ],
    }
  },
  computed: {
    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'news';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },

    subList() {
      return GlobalInstance.methods.subMenuLlist(this.$route);
    },
    currentIndex() {
      let index = GlobalInstance.methods.subTabIndex(this.$route);
      return index >=0 ? index : 0;
    },
    currentMenuItem() {
      return GlobalInstance.methods.currentMenuItem(this.$route);
    },
    newsId() {
      return this.$route.params.newsId;
    }
  },
  mounted() {
    let shareObj = this.$store.state.http.defaultShareObj;
    shareObj.title = '新闻中心 —— ' + this.tabList[this.currentIndex].title;
    shareObj.link = location.href;
    this.configShareWx(encodeURIComponent(location.href), shareObj);
  }
}
</script>

<style scoped>

  #news_top_img {
    width: 100%;
    text-align: center;
    padding: 0;
  }

  #news_top_img > img {
    height: auto;
    /*max-height: 180px;*/
    width: 100%;
  }

  #sub_menu_outer {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    padding-top: 5vh;
    padding-bottom: 5vh;
  }

  #sub_menu_content {
    width: 90%;
    max-width: 1200px;
    min-width: 290px;
    flex-wrap: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }

  #sub_menu_content img {
    max-width: 130px;
    min-width: 60px;
    width: 6vw;
  }

  #sub_menu_content > a.active {
    pointer-events: none;
  }

  #news_content_outer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    margin-bottom: 80px;
  }

  #news_content {
    width: 80%;
    min-width: 290px;
    max-width: 1200px;
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    padding: 30px 30px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/NewCenterPage.vue